import Turbolinks from "turbolinks"

const PageNavigation = {
  clearCache() {
    Turbolinks.clearCache()
  },

  isPreview() {
    return document.documentElement.hasAttribute("data-turbolinks-preview")
  },

  pushHistory(url) {
    Turbolinks.controller.pushHistoryWithLocationAndRestorationIdentifier(
      url,
      crypto.randomUUID()
    )
    Turbolinks.controller.lastRenderedLocation = new Turbolinks.Location(
      window.location.href
    )
  },

  replaceHistory(url) {
    window.history.replaceState(window.history.state, "", url)
  },

  visit(location, options) {
    Turbolinks.visit(location, options)
  },
}

export { PageNavigation }
